export const environment = {
  production: true,
  BASE_URL_RDO: 'https://app.rededeobras.com.br/',
  BASE_API_URL_RDO: 'https://api.rededeobras.com.br/api/',
  BASE_API_RDO: 'https://api.rededeobras.com.br/',
  BASE_IMG_URL: 'https://app.rededeobras.com.br/',
  BASE_IMG_MERLIM: 'https://merlincrm.com.br/img/Logotipos/',

  firebaseConfig: {
    apiKey: 'AIzaSyAanXQqKLlf5kzLFH0ndepB1zmC_ibyFAg',
    authDomain: 'ccf-web-push-notification.firebaseapp.com',
    projectId: 'ccf-web-push-notification',
    storageBucket: 'ccf-web-push-notification.firebasestorage.app',
    messagingSenderId: '931280650522',
    appId: '1:931280650522:web:05e92492080df830d06ca3',
  },

  vapidKey:
    'BJ7Dg-O-RIGKKZheHanQViWXyqzRqDDYEl_GPvkTSTJ0fY7ckgvqCkoD3s_fFEBxP47XxKZ-os-avYIiqJ12wJQ',
};
